<mat-expansion-panel
  [expanded]="expanded()"
  [hideToggle]="!hasTruncatedContent() && datashowpreview()"
  (opened)="expanded.set(true)"
  (closed)="expanded.set(false)"
  #panel
  [class.show--preview]="hasTruncatedContent()"
  [class.show--all]="!hasTruncatedContent() && datashowpreview()"
>
  <mat-expansion-panel-header>
    <mat-panel-title class="item-title">
      <span class="d-inline-block w-100 fs-body-lg fw-semi lh-sm">{{ datadisplaytitle() || datatitle() }}</span>
    </mat-panel-title>

    <!-- <mat-panel-description>
      <app-markdown [content]="previewHtml()"></app-markdown>
    </mat-panel-description> -->
    @if (!panel.expanded && hasTruncatedContent()) {
      <button
        class="button button--light-secondary button--xs expansion-panel-preview-button"
        type="button"
        (click)="$event.stopPropagation(); expanded.set(true)"
      >
        Lees meer
      </button>

      <button class="mat-expansion-panel-content-overlay" type="button" (click)="$event.stopPropagation(); expanded.set(true)"></button>
    }
  </mat-expansion-panel-header>

  <div #content>
    <ng-content />

    <!-- @if (expanded() && hasTruncatedContent()) {
      <button
        class="button button--primary button--xs expansion-panel-preview-button"
        type="button"
        (click)="$event.stopPropagation(); expanded.set(false)"
      >
        Toon minder
      </button>
    } -->
  </div>
</mat-expansion-panel>
